import React from 'react';
import { twMerge } from 'tailwind-merge';

import type { INavigationProps } from './INavigationProps';

const NavigationHeader = React.forwardRef<HTMLDivElement, INavigationProps>(
  (props: INavigationProps, forwardRef) => {
    const {
      title,
      suffixIcon: Suffix = null,
      prefixIcon: Prefix = null,
      subtitle,
      className,
      ...rest
    } = props;
    return (
      <nav
        role="navigation"
        aria-label="navigation"
        className={twMerge(
          'flex overflow-clip max-h-[12] w-screen z-10 items-center px-4 py-3 bg-white',
          className
        )}
        ref={forwardRef}
        {...rest}
      >
        {Prefix ? (
          <div className="flex text-start" tabIndex={0}>
            {Prefix}
          </div>
        ) : null}
        <div className="flex w-full flex-col items-center gap-1 text-center ">
          <span className="text-mobile-gray-600 text-sm font-medium">
            {title}
          </span>
          {subtitle ? <span>{subtitle}</span> : null}
        </div>
        {Suffix ? (
          <div className="ml-auto" tabIndex={0}>
            {Suffix}
          </div>
        ) : null}
      </nav>
    );
  }
);

NavigationHeader.displayName = 'NavigationHeader';

export default NavigationHeader;
